import React from 'react';
import image from './404.png';

export default function NoPage() {
    return <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <div>Error 404: Page Not Found</div>
        <img src={image} alt="404"/>
        <a href="/">Home</a>
    </div>;
}